import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, isEmpty as _isEmpty, } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { showAlertMessage, ErrorMessage } from "../../../../resusableComponents/common/formElements";

import { SingleDropzone, Select } from "../../../../resusableComponents/common/formElements";
import DownloadSampleFile from "../../../../resusableComponents/common/DownloadSampleFile";

import { saveCustomFields, doGetCustomFieldTypeList } from "../../../..//redux/services/campaignSetup";

import { resetCampaignSetupError, updateCampaignSetupDetails } from "../../../../redux/actions/campaignSetup";
import { updateLoadingState } from "../../../../redux/actions/application";

// Field types for which the "Values" textarea should be displayed
const FIELD_TYPES_WITH_VALUES = ["dropdown", "checkbox", "radio"];

class UploadCustomFields extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fileUploaded: false,
      lastInsertedId: null,
      uploadedFileName: "",
      uploadedFileURL: "",
      disabled: false,
      isEditMode: false,
      uploadedCustomFields: [{ field_name: "", field_type: "Textbox", is_required: false, required_values: "" }],
      fieldTypes: [],
      errors: []
    };
  }

  componentDidMount() {
    const { source = "", summary, existingCustomFields = [], currentStep } = this.props;
    const { uploadedCustomFields } = this.state;
    const tmpAllUploadedCustomFields = (source !== "campaign_edit") ? _get(summary, `[${currentStep}].allUploadedCustomFields`, []) : existingCustomFields;

    if (!_isEmpty(tmpAllUploadedCustomFields)) {
      const mergedCustomFields = [...tmpAllUploadedCustomFields, ...uploadedCustomFields];
      const finalUploadedCustomFields = (mergedCustomFields || []).filter(item => item.field_name.trim() !== "");

      this.setState({ uploadedCustomFields: finalUploadedCustomFields });
    }

    this._getCustomFieldTypeList();
  }

  componentDidUpdate(prevProps, prevStates) {

    if (!_isEqual(prevProps.existingCustomFields, this.props.existingCustomFields)) {
      const { existingCustomFields } = this.props;

      this.setState({ uploadedCustomFields: existingCustomFields, errors: [] });

      // Modal-driven usage (source === "campaign_edit") may not remount this component every time
      // the modal is (re)opened, so refetch the field types whenever the parent pushes fresh data.
      this._getCustomFieldTypeList();
    }

    if (!_isEqual(prevProps.callCustomFieldSubmitAPI, this.props.callCustomFieldSubmitAPI) && (_get(this.props, "callCustomFieldSubmitAPI", false) === true)) {

      this._submitCustomFields();

      // Reset the parent-owned trigger immediately so a subsequent Submit click (e.g. after a
      // failed validation) produces a fresh false -> true transition and re-runs validation.
      if (typeof this.props.resetSubmitFlag === "function") { this.props.resetSubmitFlag(); }
    }
  }

  _getCustomFieldTypeList = async () => {
    const { updateLoadingState } = this.props;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetCustomFieldTypeList();

      if (_get(response, "flag", false) === true) {

        const fieldTypes = (_get(response, "data", []) || []).map((fieldType) => ({
          id: _get(fieldType, "Id", null),
          name: _get(fieldType, "field_type", ""),
        }));

        this.setState({ fieldTypes });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching custom field types."));
        this.setState({ fieldTypes: [] });
      }
    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching custom field types."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  isValuesFieldApplicable = (fieldType) => FIELD_TYPES_WITH_VALUES.includes((fieldType || "").toLowerCase());

  getDefaultFieldType = () => _get(this.state.fieldTypes, "[0].name", "textbox");

  handleAddField = (name = "") => {
    this.setState((prevState) => ({
      uploadedCustomFields: [
        ...prevState.uploadedCustomFields,
        { field_name: (name || ""), field_type: this.getDefaultFieldType(), is_required: false, required_values: "" }
      ]
    }));
  };

  handleFieldChange = (index, key, value) => {
    const updatedFields = [...this.state.uploadedCustomFields];
    updatedFields[index][key] = value;

    const updatedErrors = [...this.state.errors];
    if (updatedErrors[index]) {
      updatedErrors[index] = { ...updatedErrors[index], [key]: "" };
    }

    this.setState({ uploadedCustomFields: updatedFields, errors: updatedErrors });
  };

  handleRemoveField = (index) => {
    const updatedFields = [...this.state.uploadedCustomFields];
    updatedFields.splice(index, 1);

    const updatedErrors = [...this.state.errors];
    updatedErrors.splice(index, 1);

    this.setState({ uploadedCustomFields: updatedFields, errors: updatedErrors });
  };

  _validateCustomFields = () => {
    const { intl } = this.props;
    const { uploadedCustomFields } = this.state;
    const requiredFieldMessage = intl.formatMessage({ id: "error.required_field", defaultMessage: "This field is required." });
    let isValid = true;

    const errors = (uploadedCustomFields || []).map((field) => {
      if ((_get(field, "field_name", "") || "").trim() === "") { return {}; }

      const fieldErrors = {};

      if ((_get(field, "field_type", "") || "").trim() === "") {
        fieldErrors.field_type = requiredFieldMessage;
        isValid = false;
      }

      if (this.isValuesFieldApplicable(_get(field, "field_type", "")) && (_get(field, "required_values", "") || "").trim() === "") {
        fieldErrors.required_values = requiredFieldMessage;
        isValid = false;
      }

      return fieldErrors;
    });

    this.setState({ errors });
    return isValid;
  };

  async _submitCustomFields() {
    const { source = "", goToNext, campaignId, selectedCampaignId, updateLoadingState, intl } = this.props;
    const { uploadedCustomFields } = this.state;
    const finalUploadedCustomFields = (uploadedCustomFields || [])
      .filter(item => item.field_name.trim() !== "")
      .map(item => ({
        ...item,
        required_values: (_get(item, "required_values", "") || "")
          .split(/\r?\n/)
          .map(value => value.trim())
          .filter(value => value !== "")
          .join("|"),
      }));

    if (source === "campaign_setup" && (_isEmpty(finalUploadedCustomFields || []))) {
      goToNext(finalUploadedCustomFields);
      return false;
    } else if (source === "campaign_edit" && (_isEmpty(finalUploadedCustomFields || []))) {
      showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "campaign_setup.custom_fields.title", defaultMessage: "custom fields" }) }
      ));
      return false;
    }

    if (!this._validateCustomFields()) {
      return false;
    }

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      if (typeof saveCustomFields === "function") {

        const payload = {
          campaignId: (source === "campaign_edit") ? selectedCampaignId : campaignId,
          data: {
            json: finalUploadedCustomFields,
          },
        };

        const response = await saveCustomFields(payload);
        if ((response.flag || false) === true) {

          showAlertMessage(_get(response, "data.message", "Custom fields saved successfully."), "success");
          if (typeof goToNext === "function") { goToNext(finalUploadedCustomFields) };
        } else {
          showAlertMessage(_get(response, "message", "Something went wrong while saving custom fields."));
        }
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while saving custom fields."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  renderCustomFields = () => {
    const { uploadedCustomFields, fieldTypes, errors } = this.state;

    return (
      <>
        <button
          type="button"
          className="btn btn-primary text-capitalize mb-3"
          onClick={() => this.handleAddField()}
        >
          <FormattedMessage id="campaign_setup.custom_fields.add_title" defaultMessage="Add Custom Field" />
        </button>

        <table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.name" defaultMessage="name" /></th>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.type" defaultMessage="type" /></th>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.is_required" defaultMessage="is required" /></th>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.action" defaultMessage="action" /></th>
            </tr>
          </thead>
          <tbody>
            {uploadedCustomFields.map((field, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={_get(field, "field_name", "")}
                      onChange={(e) => this.handleFieldChange(index, "field_name", _get(e, "target.value", ""))}
                    />
                  </td>
                  <td>
                    <Select
                      className="form-custom-select"
                      placeholder="Select Field Type"
                      options={fieldTypes}
                      value={fieldTypes.find(opt => opt.name === _get(field, "field_type" || ""))}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.name}
                      onChange={(selected) => this.handleFieldChange(index, "field_type", selected.name)}
                      isMulti={false}
                      error={_get(errors, `[${index}].field_type`, "")}
                    />
                  </td>
                  <td className="text-center">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      value={(_get(field, "is_required", false) === true) ? 1 : 0}
                      checked={_get(field, "is_required", false)}
                      onChange={(e) => this.handleFieldChange(index, "is_required", e.target.checked)}
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm text-capitalize"
                      onClick={() => this.handleRemoveField(index)}
                    >
                      <FormattedMessage id="campaign_setup.custom_fields.remove" defaultMessage="remove" />
                    </button>
                  </td>
                </tr>
                {this.isValuesFieldApplicable(_get(field, "field_type", "")) && (
                  <tr>
                    <td colSpan={4}>
                      <label className="form-label fw-bold text-capitalize mb-1">
                        <FormattedMessage id="campaign_setup.custom_fields.column.values" defaultMessage="values" />
                      </label>
                      <textarea
                        className={`form-control${_get(errors, `[${index}].required_values`, "") ? " is-invalid" : ""}`}
                        rows={3}
                        value={_get(field, "required_values", "")}
                        onChange={(e) => this.handleFieldChange(index, "required_values", _get(e, "target.value", ""))}
                      />
                      {_get(errors, `[${index}].required_values`, "") && (
                        <ErrorMessage message={_get(errors, `[${index}].required_values`, "")} />
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </>
    );
  };

  render = () => {
    const { source, campaignId, selectedCampaignId, clientId, allowedCustomFieldsFiles, allowedCustomFieldsFilesLabel } = this.props;
    const { uploadedFileName, uploadedFileURL, lastInsertedId } = this.state;

    return (
      <>
        <div className="row">
          <div className="col-lg-8">
            <div className="mb-3">
              <SingleDropzone
                acceptedFormat={allowedCustomFieldsFiles}
                allowedExtensions={allowedCustomFieldsFilesLabel}
                setState={(args) => this.setState(args)}
                addCustomField={(uploadedFields) => {
                  const defaultFieldType = this.getDefaultFieldType();
                  let allCustomFields = [];
                  (uploadedFields || []).forEach((field) => {
                    allCustomFields.push({
                      field_name: (field || ""),
                      field_type: defaultFieldType,
                      is_required: false,
                      required_values: "",
                    });
                  });
                  this.setState((prevState) => ({
                    uploadedCustomFields: (allCustomFields || []),
                    errors: []
                  }));
                }}
                source="custom_fields"
                campaignId={(source === "campaign_edit") ? (selectedCampaignId || null) : (campaignId || null)}
                clientId={(clientId || null)}
                uploadedFileName={uploadedFileName}
                uploadedFileURL={uploadedFileURL}
                lastInsertedId={lastInsertedId}
                preserveSelectedFile={true}
                displayUploadedFiles={true}
                displayUploadedRemoveBtn={true}
              />
            </div>
            <p className="fw-bold text-grey-74 mb-3">
              <FormattedMessage id="campaign_setup.custom_fields.note" defaultMessage="Note: Please be aware that uploading a new file will replace the existing fields in the table list with those from the new file." />
            </p>
            <DownloadSampleFile source="custom_fields" />
          </div>
          <div className="mt-4">
            {this.renderCustomFields()}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  summary: _get(state, "campaignSetup.summary", {}),
  clientId: _get(state, "campaignSetup.summary.common.clientId", null),
  campaignId: _get(state, "campaignSetup.summary.common.campaignId", null),
  currentStep: _get(state, "campaignSetup.summary.common.currentStep", 1),
  allowedCustomFieldsFiles: _get(state, "application.constants.allowedCustomFieldsFiles", ""),
  allowedCustomFieldsFilesLabel: _get(state, "application.constants.allowedCustomFieldsFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
  resetCampaignSetupError: () => dispatch(resetCampaignSetupError()),
  updateCampaignSetupDetails: (data) => dispatch(updateCampaignSetupDetails(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UploadCustomFields));
